import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetDistance(
  salesOrg: string,
  customerNum: string,
  miles: number
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      miles,
    },
    url: `${BASE_URL}/api/customers/within`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
